import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const tinnitus: AnswerPathTreeNode = {
  path: 'tinnitus',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredTinnitusDetails }],
};
